import { Either, Left, Right } from 'fp-ts/lib/Either'

import { log } from '@/log'
import { ApiClient } from './client'
import { ShopEntryApiErrorResponse } from './shop-entry/response'

const namespace = 'shop-entry-api'

export class ShopEntryApiService {
  constructor(
    private readonly apiClient: typeof ApiClient = ApiClient
  ) {}

  /**
   * TODO: shop id or appidを指定させても良いかも
   * 今はserver側でviewedPathから導出している
   */
  async update(viewedPath: string): Promise<Either<ShopEntryApiErrorResponse, null>> {
    try {
      const response = await this.apiClient.put('/api/user/shop-entry/update', {
        viewed_path: viewedPath,
      })

      log.debug({ service: `${namespace}/update`, response })

      return new Right(null)
    } catch (error) {
      log.error({ service: `${namespace}/update`, error })
      const response = (error as any).response

      const errorResponse = response
        ? ShopEntryApiErrorResponse.fromResponse(response)
        : ShopEntryApiErrorResponse.fromString(error instanceof Error ? error.message : String(error))

      this.handleError(errorResponse)

      return new Left(errorResponse)
    }
  }

  private handleError(error: ShopEntryApiErrorResponse) {
      // 入店制限によって入店拒否されれば /entrance/* にリダイレクト
    if (error.errorCode === 'entry_rejected') {
      const currentPath = location.pathname.replace(/^\//, '')
      const currentQuery = location.search

      location.href = `/entrance/${currentPath}${currentQuery}`
    }
  }
}
